module.exports = __webpack_public_path__ + "img/zdh.b6d504f.png";